import {
  type ForwardedRef,
  forwardRef,
  type ReactElement,
  type TextareaHTMLAttributes,
} from 'react';

import { cn } from '@/shared/lib/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef(function Textarea(
  { className, rows = 3, ...props }: TextareaProps,
  ref: ForwardedRef<HTMLTextAreaElement>,
): ReactElement {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-soft-1',
        'transition-[border-color,box-shadow] duration-150 ease-out-expo',
        'placeholder:text-muted-foreground',
        'focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'resize-y min-h-[80px]',
        className,
      )}
      {...props}
    />
  );
});
